export default "__VITE_PUBLIC_ASSET__a589893b__"